import * as types from '../mutation-types'
import axios from "axios";
import { bugsnagClient } from "~/plugins";
import client from "../../plugins/bugsnag";
import {VERSION_INFO_FAILURE, VERSION_INFO_SUCCESS} from "../mutation-types";

// state
export const state = {
  darkmode: window.localStorage.getItem('nightmode') === 'true',
  trade_engines_statuses: null,
  version: null
};

// getters
export const getters = {
  darkmode: state => state.darkmode,
  trade_engines_statuses: state => {
    return state.trade_engines_statuses;
  },
  version: state => state.version
};

// mutations
export const mutations = {
  [types.SET_DARKMODE](state, darkmode) {
    state.darkmode = darkmode;
  },
  [types.FETCH_ALL_TRADE_ENGINE_STATUS_SUCCESS](state, { result }) {
    state.trade_engines_statuses = result;
  },
  [types.FETCH_ALL_TRADE_ENGINE_STATUS_FAILURE]() {},
  [types.VERSION_INFO_SUCCESS](state, { result }) {
    state.version = result;
  },
  [types.VERSION_INFO_FAILURE]() {}
};

// actions
export const actions = {
  setDarkMode({ commit, dispatch }, darkmode) {
    commit(types.SET_DARKMODE, darkmode);
  },
  async fetchTradeEngineStatuses({ commit }) {
    try {
      const { data } = await axios.get(
        "/api/v1/settings/get-engine-trade-status"
      );
      commit(types.FETCH_ALL_TRADE_ENGINE_STATUS_SUCCESS, {
        result: data.data
      });
    } catch (error) {
      commit(types.FETCH_ALL_TRADE_ENGINE_STATUS_FAILURE);

      bugsnagClient.notify(error);
    }
  },
  async fetchVersion({ commit }) {
    try {
      const { data } = await axios.get("/version.json");
      commit(types.VERSION_INFO_SUCCESS, {
        result: data["Commit id"]
      });
    } catch (error) {
      commit(types.VERSION_INFO_FAILURE);

      bugsnagClient.notify(error);
    }
  }

};



// WEBPACK FOOTER //
// ./resources/js/store/modules/settings.js